<template>
    <tr :class="`${isEditRequested || isResolveRequested || isAddRequested ? 'edit-row' : ''}`">
        <td :colspan="`${isEditRequested || isAddRequested ? '2' : '1'} `" class="align-top">
            <div class="form-group mb-0" v-if="isEditRequested || isAddRequested">
                <Diagnosis
                    :selected-diagnosis="selectedDiagnosis"
                    :diagnosis-changed="diagnosisChanged"
                    :disabled="snapshotView"
                    :application="application"
                />
            </div>
            <span v-else>
                <EmptyTextHandler :text="diag.Code" />
            </span>
        </td>
        <td v-if="!isEditRequested && !isAddRequested">
            <EmptyTextHandler :text="diag.Description" />
        </td>
        <td class="align-top">
            <div class="form-group mb-0" v-if="isEditRequested || isAddRequested">
                <DatePicker :getDate="handleDateChange">
                    <div class="input-group date datepickerInput">
                        <input
                            name="startDate"
                            type="text"
                            class="form-control"
                            placeholder="MM/DD/YYYY"
                            :value="formatDateInput(diag.StartDate)"
                            @change="handleDate"
                            autocomplete="off"
                            :disabled="snapshotView"
                        />
                        <div class="input-group-addon input-group-append">
                            <div class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </div>
                        </div>
                    </div>
                </DatePicker>
            </div>
            <EmptyTextHandler :text="formatDate(diag.StartDate)" v-else />
        </td>
        <td class="align-top" v-if="!hideResolved && historyView">
            <div class="form-group mb-0" v-if="isEditRequested || isAddRequested">
                <DatePicker :getDate="handleDateChange">
                    <div class="input-group date datepickerInput">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="MM/DD/YYYY"
                            :value="formatDateInput(diag.ResolvedDate)"
                            autocomplete="off"
                            :disabled="snapshotView"
                            @change="handleDate"
                        />
                        <div class="input-group-addon input-group-append">
                            <div class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </div>
                        </div>
                    </div>
                </DatePicker>
            </div>
            <EmptyTextHandler :text="formatDate(diag.ResolvedDate)" v-else></EmptyTextHandler>
        </td>

        <template v-if="!isDeleteRequested">
            <td class="text-end" v-if="!isEditRequested && !isResolveRequested && !isAddRequested">
                <button
                    class="btn table-btn btn-outline-info me-1"
                    @click="moveDiagnosisUp(index, index - 1)"
                    v-if="!first && !snapshotView"
                    v-tooltip="{ title: 'Move Diagnosis Up' }"
                    :disabled="isViewDetailsRequested"
                >
                    <i class="fas fa-chevron-up"></i>
                </button>
                <button
                    class="btn table-btn btn-outline-info me-1"
                    @click="moveDiagnosisDown(index, index + 1)"
                    v-if="!last && !snapshotView"
                    v-tooltip="{ title: 'Move Diagnosis Down' }"
                    :disabled="isViewDetailsRequested"
                >
                    <i class="fas fa-chevron-down"></i>
                </button>
                <span v-if="!historyView && snapshotView"><i>No Actions</i></span>

                <button
                    v-else
                    class="btn table-btn btn-outline-info"
                    @click="openEditDiagnosis()"
                    :disabled="isViewDetailsRequested"
                >
                    <i class="fas fa-edit"></i>
                </button>
                <div class="btn-group table-btn-group" v-if="!snapshotView && !historyView">
                    <button
                        type="button"
                        class="btn px-1 py-0 btn-outline-primary dropdown-toggle"
                        data-bs-toggle="dropdown"
                        :id="`DiagnosisRow__Actions${diag.Order}`"
                        :disabled="isViewDetailsRequested"
                    >
                        <i class="fas fa-ellipsis-h"></i>
                    </button>
                    <div class="dropdown-menu" :aria-labelledby="`DiagnosisRow__Action${diag.Order}`">
                        <a class="dropdown-item" href="javascript:void(0);" @click="openResolveDiagnosis(index)">
                            Resolve
                        </a>
                        <a class="dropdown-item" href="javascript:void(0);" @click="openDeleteDiagnosis(index)">
                            Delete
                        </a>
                    </div>
                </div>
            </td>
        </template>
        <td :colspan="2" class="p-2 edit" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="Yes, Delete"
                name="delete"
                :ok="deleteDiag"
                :cancel="cancelDeleteRequest"
                :message="deleteMessage"
                cancel-text="No"
                :include-yes="false"
            />
        </td>
        <td class="text-end" v-if="isResolveRequested">
            <i>Diagnosis Resolution In Progress</i>
        </td>
        <td class="button-cell text-end" v-if="isEditRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="saveEditDiagnosis()">Add</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelEditDiagnosis()">
                Cancel
            </button>
        </td>
        <td class="button-cell text-end" v-if="isAddRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="save()">Add</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelSaveNewDiagnosis(index)">
                Cancel
            </button>
        </td>
    </tr>
    <tr v-if="isResolveRequested" class="row-no-hover edit-row">
        <td :colspan="columns" class="p-2 edit">
            <div class="d-flex flex-column align-items-center">
                <div class="form-group w-25 mb-2">
                    <label for="resolution-date"> Resolution Date </label>
                    <DatePicker :options="resolveDatePickerOptions" :getDate="handleDateChange">
                        <div class="input-group date datepickerInput">
                            <input
                                name="resolvedDate"
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="MM/DD/YYYY"
                                :value="formatDateInput(resolvedDate)"
                                @change="handleDate"
                                autocomplete="off"
                                date-format-only
                            />
                            <div class="input-group-addon input-group-append">
                                <div class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                    </DatePicker>
                </div>
                <div>
                    <button class="btn btn-xs btn-outline-primary me-1" @click="saveResolveDiagnosis(index)">
                        Save
                    </button>
                    <button class="btn btn-xs btn-outline-secondary" @click="cancelResolveDiagnosis(index)">
                        Cancel
                    </button>
                </div>
            </div>
        </td>
    </tr>
    <tr v-if="diag.IsRelated == false" class="row-no-hover edit-row">
        <td :colspan="columns" class="p-2 edit">
            <div class="d-flex flex-column align-items-center">
                <div class="form-group w-50">
                    <label for="not-related-reason">Reason<span class="text-danger">*</span></label>
                    <CommentInput
                        input-name="not-related-comments"
                        :result="diag.NotRelatedComments"
                        placeholder="Specify rationale and pertinent medical management information."
                        :max-length="2000"
                        :application="application"
                    />
                </div>
            </div>
        </td>
    </tr>
</template>

<script src="./DiagnosisTableRow.ts"></script>
